<template>
  <Transition :name="transitionName" mode="out-in">
    <div :key="stepIndex" class="tw:flex tw:flex-col tw:gap-3 tw:tour-will-change">
      <h3 class="tw:heading-2 tw:text-black tw:leading-tight tw:tour-will-change-clip tour-content-title">
        {{ title }}
      </h3>
      <p class="tw:body-1 tw:text-default-700 tw:leading-relaxed tw:tour-will-change-clip tour-content-description">
        {{ description }}
      </p>
    </div>
  </Transition>
</template>

<script lang="ts" setup>
defineProps<{
  title: string;
  description: string;
  stepIndex: number;
  transitionName: string;
}>();
</script>

<style scoped>
.slide-up-enter-active,
.slide-up-leave-active,
.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.slide-up-enter-active .tour-content-title,
.slide-down-enter-active .tour-content-title {
  animation: tour-typewriter-in 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
}

.slide-up-enter-active .tour-content-description,
.slide-down-enter-active .tour-content-description {
  animation: tour-fade-slide-in 0.5s cubic-bezier(0.22, 1, 0.36, 1) 0.15s forwards;
  opacity: 0;
}

.slide-up-enter-from {
  opacity: 0;
  transform: translateX(30px);
}

.slide-up-leave-to {
  opacity: 0;
  transform: translateX(-30px);
}

.slide-down-enter-from {
  opacity: 0;
  transform: translateX(-30px);
}

.slide-down-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>
